import type { PerformanceDatapoint } from 'owa-analytics';

/*
    Add custom data points related to the online meeting setting.
    Event properties are logged through logEventMetricProperties. Here we are logging UI state properties.
*/
export default function logOnlineMeetingMetrics(
    datapoint: PerformanceDatapoint,
    newMeeting: boolean,
    isOnlineMeeting: boolean,
    isOnlineMeetingExplicitlySet: boolean,
    wasOnlineMeetingEverAutoSet: boolean
) {
    if (newMeeting) {
        // If the online meeting setting was automatically set, and the user explicitly set it to off,
        // then we want to know that the user overrode the automatic setting.
        const didUserOverrideOnlineMeetingAutoSet: boolean =
            wasOnlineMeetingEverAutoSet && isOnlineMeetingExplicitlySet && !isOnlineMeeting;
        datapoint.addCustomData({
            wasOnlineMeetingEverAutoSet: wasOnlineMeetingEverAutoSet,
            didUserOverrideOnlineMeetingAutoSet: didUserOverrideOnlineMeetingAutoSet,
        });
    }
}
